module.exports = __webpack_public_path__ + "img/online-web.c085391d.svg";